
import React, { useState, useEffect } from 'react';

export const OfflineNotice = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOnline) return null;

    return (
        <div className="bg-red-500 text-white text-xs font-bold py-2 px-4 text-center animate-slide-up flex items-center justify-center gap-2 sticky top-[74px] z-[55] shadow-md">
            <span className="material-symbols-outlined text-sm">wifi_off</span>
            Estás desconectado. Algunas funciones pueden no estar disponibles.
        </div>
    );
};
